import React from 'react';
import { useMainPerformanceTotalSales, useMainPerformanceAverageInvoice } from '../../../hooks/useMainPerformanceKPIs';
import KPICard from '../../ui/KPICard';
import LoadingSpinner from '../../ui/LoadingSpinner';
import ErrorMessage from '../../ui/ErrorMessage';
import { KPIProps } from '../../../types/kpi';
import {formatCurrency} from '../../../utils/formatters'


const TotalSalesKPI: React.FC<KPIProps> = ({
  branchId = 0,
  timeRange = 'last6Months',
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data, isLoading, isError, error, refetch } = useMainPerformanceTotalSales(branchId, timeRange);
  const { data: avgInvoiceData } = useMainPerformanceAverageInvoice(branchId, timeRange);

  // Handle error callback
  React.useEffect(() => {
    if (isError && error && onError) {
      onError(error as Error);
    }
  }, [isError, error, onError]);

  // // Helper function to format currency values
  // const formatCurrency = (value: number | string): string => {
  //   if (typeof value === 'string') return value;
  //   if (!value && value !== 0) return '0';
  //   return new Intl.NumberFormat('fa-IR').format(Math.round(value));
  // };

  // // Helper function to format numbers
  // const formatNumber = (value: number | string): string => {
  //   if (typeof value === 'string') return value;
  //   if (!value && value !== 0) return '0';
  //   return new Intl.NumberFormat('fa-IR').format(Math.round(value));
  // };

  if (isLoading && showLoading) {
    return (
      <div className={`animate-enter animate-delay-1 ${className}`}>
        <div className="card-base card-padding">
          <div className="flex items-center justify-center h-32">
            <LoadingSpinner variant="minimal" size="md" />
          </div>
        </div>
      </div>
    );
  }

  if (isError && error) {
    return (
      <ErrorMessage 
        message="خطا در دریافت اطلاعات فروش"
        onRetry={() => refetch()}
        className={className}
      />
    );
  }

  const kpiData = data || {
    totalSales: 0,
    totalInvoices: 0,
    currency: { currency_symbol: 'تومان' }
  };

  const averageInvoice = Math.round(avgInvoiceData?.averageInvoiceValue) || 0;
  console.log(averageInvoice)
  return (
    <KPICard
      title="فروش کل"
      value={formatCurrency(kpiData.totalSales,kpiData.currency?.currency_symbol || "تومان")}
      currency={kpiData.currency?.currency_symbol || "تومان"}
      subtitle={`میانگین سفارش: ${formatCurrency(averageInvoice, kpiData.currency?.currency_symbol || "تومان")}`}
      variant="primary"
      accentStyle="corner"
      className={`animate-enter-up stagger-1 ${className}`}
      loading={isLoading && !showLoading}
    />
  );
};

export default TotalSalesKPI;